import React from 'react';
import styled from 'styled-components';

import { observer } from 'mobx-react';
import { Option, OptionWrapper } from 'libs/forms/styles';

export const ProjectTypeOption = observer(
  ({ app, highlighted, onClick, onMouseOver, scrollRef }) => (
    <ProjectTypeOptionWrapper
      highlighted={highlighted}
      onMouseOver={onMouseOver}
      onClick={onClick}
      ref={scrollRef}
    >
      <Option highlighted={highlighted} disabled={app.disabled}>
        {app.label}
      </Option>
    </ProjectTypeOptionWrapper>
  ),
);

const ProjectTypeOptionWrapper = styled(OptionWrapper)`
  &:hover {
    > p > a {
      opacity: 1;
    }
  }
`;
